<template>
  <div class="options">
    <div
      :key="oidx"
      v-for="(option, oidx) in options"
      @mouseover="hoverOption(option.Picture)"
      @mouseleave="leaveOption(content.step.selectedOption.Picture)"
      class="singleOption"
    >
      <img
        class="-hideForMd"
        v-bind:src="content.step.selectedOption.Picture.Src"
        v-if="content.step.selectedOption.Picture"
      />
      <label
        class="option"
        :class="{
          '-disabled': !option.isValid,
          '-active': picked == option.Id || (option.Id == content.step.selectedOption.Id && picked == null),
        }"
      >
        <input
          type="radio"
          :value="option.Id"
          :disabled="!option.isValid"
          v-model="picked"
          :checked="option.Id == content.step.selectedOption.Id"
        />
        <span class="optionText">
          <span>{{ option.Title }}</span>
          <span v-if="!option.isValid"> (NA)</span>
          <!-- <span> (!)</span> -->
        </span>
        <span class="optionUnavailableTooltip">
          {{ content.unavailableLabel }}
        </span>
        <div
          class="optionDesc"
          :class="{ '-show': content.step.moreInfo }"
          v-html="option.Description"
        ></div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Option",
  props: ["content"],
  data() {
    return {
      picked: null,
    };
  },
  emits: ["select-option", "set-image", "unset-image"],
  computed: {
    options: function () {
      // Sorting the options to have the invalid ones last
      const opts = this.content.step.Options.slice(0).sort(function (a, b) {
        return a.isValid === b.isValid ? 0 : a.isValid ? -1 : 1;
      });

      return opts;
    },
  },
  watch: {
    picked() {
      let selectedOption = this.options.find((opt) => {
        return opt.Id === this.picked;
      });

      this.$emit("select-option", this.content.step, { Id: selectedOption.Id });
    },
  },
  methods: {
    hoverOption(pic) {
      if (pic && pic.Src) {
        this.$emit("set-image", this.content.step, pic.Src);
      }
    },
    leaveOption(pic) {
         if (pic && pic.Src) {
      this.$emit("unset-image", this.content.step, pic.Src);
      }
    },
  },
  beforeMount() {
    if (this.options[0]) {
      this.$emit(
        "select-option",
        this.content.step,
        { Id: this.content.step.DefaultOption },
        true
      );
    }
  },
};
</script>

<style lang="scss">
@import "../style/_vars";

.t-priceCalculator {
  .singleOption {
    @include respond-below(md) {
      display: flex;
      flex-flow: row wrap;
      margin-bottom: 1rem;

      label {
        flex: 1;
        margin: 0;
      }
    }
  }

  .option {
    display: block;
    line-height: 2em;
    padding: 0 0.5rem;
    cursor: pointer;
    position: relative;
    z-index: 1;
    margin-bottom: 1em;

    &.-active {
      background: $colorLightBlue;
    }

    &.-disabled {
      color: lightgray;

      &:hover {
        .optionUnavailableTooltip {
          display: block;
        }
      }

      + * {
        color: lightgray;
      }
    }

    input {
      margin-right: 0.5rem;
      margin-top: 0;
    }

    &Text {
      font-weight: bold;
    }

    &Desc {
      display: block;
      margin: 0;

      ul:not([data]) {
        list-style: disc;
        padding: 0 1rem;
      }
    }

    &UnavailableTooltip {
      background: $colorLightBlue;
      color: black;
      border: 1px solid darkslateblue;
      position: absolute;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      padding: 0.2rem 0.5rem;
      white-space: nowrap;
      display: none;

      &:before {
        content: "";
        display: inline-block;
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        border-top: 0.8rem solid transparent;
        border-bottom: 0.8rem solid transparent;
        border-left: 0.8rem solid transparent;
        border-right: 0.8rem solid darkslateblue;
      }

      @include respond-below(sm) {
        display: none !important;
      }
    }
  }
}
</style>
